import { track } from './AmplitudeAnalytics';

enum AnalyticsEvent {
  HEARING_EVENTS_FILTERED = 'Filter Hearing Events',
}

export const trackHearingEventsFiltered = (
  committees?: string[],
  sessions?: string[],
  fromDate?: string,
  toDate?: string,
  username?: string,
  workspaces?: string[],
  workspaceFilterMode?: string,
): void => {
  track(AnalyticsEvent.HEARING_EVENTS_FILTERED, {
    committees: committees?.join(', '),
    sessions: sessions?.join(', '),
    fromDate,
    toDate,
    username,
    workspaces: workspaces?.join(', '),
    workspaceFilterMode,
  });
};
